import { render, staticRenderFns } from "./PasswordRecoverForm.vue?vue&type=template&id=3d703d20&scoped=true&"
import script from "./PasswordRecoverForm.vue?vue&type=script&lang=js&"
export * from "./PasswordRecoverForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordRecoverForm.vue?vue&type=style&index=0&id=3d703d20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d703d20",
  null
  
)

export default component.exports